<ion-header no-border>
  <ion-toolbar>

    <ion-buttons slot="start">
      <ion-button ion-button (click)="dismiss()" data-cy="editMicrosite-toolbar-dismiss">
        <ion-icon color="dark" class="modal-close" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-buttons slot="end">
      <ion-button class="toolbarButton" color="primary" ion-button ion-button [disabled]="isDisabled" (click)="done()"
        data-cy="editMicrosite-toolbar-save">
        Save
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-header>

<ion-content class="padding">

  <h3 class="text-center color-dark" data-cy="editMicrosite-form-title">
    Edit {{inputLabel}}
  </h3>

  <div class="spacer-20"></div>

  <ion-item lines="none">
    <ion-textarea autocapitalize="sentences" #ionTextarea [(ngModel)]="inputData" rows="1" (keydown)="limitText();"
      (ngModelChange)="limitText();" (keyup)="limitText();" data-cy="editMicrosite-form-input"></ion-textarea>
  </ion-item>

  <div class="counter-container">

    <span [ngClass]="isDark ? 'count-dark' : 'count-danger'" data-cy="editMicrosite-form-charsLeft">
      <b>{{countdown}} characters left.</b>
    </span>
    <p color="dark" data-cy="editMicrosite-form-maxCharsWarning"> Keep message length smaller than 160 characters for best delivery </p>

  </div>
  
  <div [style.padding-bottom.px]="utils.keyboardHeight"></div>
</ion-content>